<template>
  <div>
    <el-select
      clearable
      filterable
      default-first-option
      v-model="ProductId"
      placeholder="Producto"
      size="mini"
      style="margin-left: 5px"
      @change="OnproductChange"
    >
      <el-option
        v-for="(item, index) in productList"
        :key="index"
        :label="item.Description"
        :value="item.Id"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "ProductsSelector",

  data() {
    return {
      ProductId: "",
      productList: []
    };
  },

  mounted() {
    this.GetProductList();
  },

  methods: {
    async GetProductList() {
      await this.$http
        .get("/api/interactions/GetProducts", {
          params: {
            CompanyId: this.currentCompany
          }
        })
        .then((resp) => {
          this.productList = resp.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    OnproductChange(val) {
      this.$emit("ProductChanged", val);
    }
  }
};
</script>

<style scoped></style>
